import Axios from '@/axios';

// 查询人员
export const getPersons = params => {
  return Axios({
    url: '/face/web/person/index_person',
    method: 'GET',
    type: 'json',
    params
  })
}
// 创建人员
export const createPerson = data => {
  return Axios({
    url: '/face/web/person/create_person',
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改人员
export const modifyPerson = data => {
  return Axios({
    url: '/face/web/person/update_person/' + data.id,
    method: 'POST',
    type: 'json',
    data
  })
}
// 查询人员详情
export const getPersonalDetail = params => {
  return Axios({
    url: '/face/web/person/show_person/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}
// 删除人员
export const deletePerson = data => {
  return Axios({
    url: '/face/web/person/delete_person/' + data.id,
    method: 'POST',
    type: 'json',
    data
  })
}
// 查询重复人员
export const checkRepeatedPerson = params => {
  return Axios({
    url: '/face/web/person/find_same_person',
    method: 'GET',
    type: 'json',
    params
  })
}
// 查询是否有重复人员
export const checkHasRepeatedPerson = params => {
  return Axios({
    url: '/face/web/person/index_same_person',
    method: 'GET',
    type: 'json',
    params
  })
}
// 查询重复人员列表
export const getRepeatedPersonList = params => {
  return Axios({
    url: '/face/web/person/list_same_person',
    method: 'GET',
    type: 'json',
    params
  })
}
// 创建注册绑定二维码
export const createQRCode = data => {
  return Axios({
    url: '/face/web/person/create_qrcode_binding',
    method: 'POST',
    type: 'json',
    data
  })
}
// 解绑人员和微信
export const unbindWeChat = data => {
  return Axios({
    url: '/face/web/person/wx_unbinding_person',
    method: 'POST',
    type: 'json',
    data
  })
}

// 查询人员数组
export const listPerson = data => {
  return Axios({
    url: '/face/web/person/list_person_for_examine',
    method: 'POST',
    type: 'json',
    data
  })
}
